// Maps engineering "function_name" values returned by the logs API to
// user-friendly labels shown in the UI.
//
// NOTE: This list is a starting point. Gaurav is expected to provide the
// authoritative list of function_name values; add/adjust entries here as they
// are confirmed. Any function_name not present in the map falls back to a
// "prettified" version of the raw value (see prettifyFunctionName below).

const FUNCTION_NAME_LABELS = {
    // Subscribers
    addSubscriber: "Add Subscriber",
    modifySubscriber: "Modify Subscriber",
    deleteSubscriber: "Delete Subscriber",
    updateSubscriberPII: "Update Subscriber Info",
    resetSubscriptionStartDate: "Change Subscription Start Date",
    resetSubscriptionEndDate: "Change Subscription End Date",
    modifyServicePlan: "Change Service Plan",
    modifyVenueUnit: "Change Unit",
    modifySubscriptionPrice: "Change Subscription Price",

    // Venues
    addVenue: "Add Venue",
    configureVenue: "Configure Venue",
    modifyVenue: "Modify Venue",
    deleteVenue: "Delete Venue",
    disableServicePlan: "Disable Service Plan",

    // Units
    addVenueUnit: "Add Unit",
    configureVenueUnit: "Configure Unit",
    deleteVenueUnit: "Delete Unit",

    // Keypools
    addKeypool: "Add Keypool",
    configureKeypool: "Configure Keypool",
    deleteKeypool: "Delete Keypool",
    connectKeypool: "Connect Keypool",

    // Equipment
    addEquipment: "Add Equipment",
    configureEquipment: "Configure Equipment",
    deleteEquipment: "Delete Equipment",

    // Administrators / operator
    addAdministrator: "Add Administrator",
    modifyAdministrator: "Modify Administrator",
    deleteAdministrator: "Delete Administrator",
};

// Converts a raw function_name (typically camelCase or snake_case) into a
// human-readable Title Case string, e.g. "resetSubscriptionEndDate" ->
// "Reset Subscription End Date".
export const prettifyFunctionName = (raw) => {
    if (raw === undefined || raw === null || raw === "") return "";
    return String(raw)
        // snake_case and kebab-case to spaces
        .replace(/[_-]+/g, " ")
        // camelCase boundaries to spaces
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

// Returns the friendly label for a function_name, using the explicit map first
// and falling back to a prettified version of the raw value.
export const getFunctionNameLabel = (functionName) => {
    if (functionName === undefined || functionName === null || functionName === "") {
        return "";
    }
    if (FUNCTION_NAME_LABELS[functionName]) {
        return FUNCTION_NAME_LABELS[functionName];
    }
    return prettifyFunctionName(functionName);
};

// The list of {value, name} options for a function_name filter dropdown, based
// on the known map. Consumers may also merge in function names discovered in
// the current log response.
export const getFunctionNameOptions = () => {
    return Object.keys(FUNCTION_NAME_LABELS).map((value) => ({
        value,
        name: FUNCTION_NAME_LABELS[value],
    }));
};

export default getFunctionNameLabel;
